import { Skeleton, SkeletonCircle } from '@chakra-ui/react';
import {
  ListItemAvatar,
  ListItemText,
  TableList,
} from 'app/components/ChakraTableList';
import { fetchContributionClassesRolesDDLEffect } from 'app/store/SongList/effects';
import { getContributionClassesAndRoles } from 'app/store/SongList/selectors';
import { useResource } from 'app/utils/hooks';
import { useState } from 'react';
import { Collaborator } from 'types/collaborator.types';
import { ContributionClassesAndRolesDDL } from 'types/contribution';
import { getAvatarImage } from 'app/utils/utils';
import { ContactCardDialog } from 'app/components/ContactCardDialog';
import { Profile } from 'types/profile';
import { TruncatedChips } from 'app/components/Core/TruncatedChips';
import { getRolesLabel } from './utils';
import { Contribution } from '../ReadOnlyPlaylist/types';

export const PlaylistAudioCreditsTable = ({
  credits,
  onContactCardOpen,
}: {
  credits: Contribution[];
  onContactCardOpen: () => void;
}) => {
  const [openCollaborator, setOpenCollaborator] = useState<
    Pick<Collaborator, 'profile' | 'profileCard'>
  >();

  const handleAvatarClick = (
    contributor: Pick<Collaborator, 'profile' | 'profileCard'>
  ) => {
    setOpenCollaborator(contributor);
  };

  const [
    contributionClassesAndRoles = {} as ContributionClassesAndRolesDDL,
    isLoading,
  ] = useResource(
    fetchContributionClassesRolesDDLEffect,
    getContributionClassesAndRoles
  );

  return (
    <>
      <TableList
        memoizeList
        loadingOptions={{
          loading: isLoading,
          repeat: 6,
          loader: {
            accessory: (
              <SkeletonCircle
                width="40px"
                height="40px"
                borderBottomLeftRadius="10%"
                borderTopLeftRadius="10%"
              />
            ),
            name: <Skeleton height={6} />,
            roles: <Skeleton height={6} />,
          },
        }}
        columns={[
          { key: 'avatar', name: '', accessory: true },
          { key: 'name', name: 'Name' },
          { key: 'roles', name: 'Roles' },
        ]}
        rows={credits.map(({ roles: roleNames, profileCard }) => {
          const roles = getRolesLabel(
            roleNames,
            contributionClassesAndRoles.classRoles
          );
          return {
            avatar: (
              <ListItemAvatar
                initials={profileCard?.initials || ''}
                colors={profileCard?.avatarColors}
                src={getAvatarImage(profileCard?.profileImages)}
                {...(profileCard.guid
                  ? {
                      onClick: () => {
                        onContactCardOpen();
                        handleAvatarClick({
                          profileCard,
                          profile: profileCard as Profile,
                        });
                      },
                      cursor: 'pointer',
                    }
                  : {})}
              />
            ),
            name: (
              <ListItemText
                primary={profileCard?.displayName || ''}
                title={profileCard?.displayName || ''}
              />
            ),
            roles: (
              <TruncatedChips<string>
                items={roles}
                getKey={(role) => role}
                getLabel={(role) => role}
              />
            ),
          };
        })}
      />
      {openCollaborator && (
        <ContactCardDialog
          onClose={() => setOpenCollaborator(undefined)}
          isOpen={Boolean(openCollaborator)}
          collaborator={openCollaborator}
          shared
        />
      )}
    </>
  );
};
